import * as React from 'react';

import NewsArchiveCtx from '@/context/newsArchiveCtx';
import { Category } from '@/utils/functions/wordpress/fetchCategories';

import { AuthorEndpointResult } from '@/utils/functions/wordpress/fetchAuthor';
import SelectInput from './SelectInput/SelectInput';

type NewsCategoryTabsProps = {
    // Data
    categories: Category[];
    authors: AuthorEndpointResult[];
    tags: Category[];
    sort: any;
};

const NewsCategoryTabs = (props: NewsCategoryTabsProps) => {
    const {
        // Data
        categories,
        authors,
        tags,
        // sort,
    } = props;

    const newsArchiveCtx = React.useContext(NewsArchiveCtx);

    return (
        <div className="py-6 md:px-10 px-4">
            <ul className="flex items-center gap-4 sm:gap-8 flex-wrap">
                <li className="pr-4 sm:pr-8 sm:border-r border-light-gray/35">
                    <SelectInput
                        options={categories.map(category => ({ id: `${category.id}`, name: category.name }))}
                        labelName={'Category'}
                        state={newsArchiveCtx.setCategories}
                        value={newsArchiveCtx.categories}
                        multiple={true}
                    />
                </li>
                <li className="pr-4 sm:pr-8 sm:border-r border-light-gray/35">
                    <SelectInput
                        options={authors.map(author => ({ id: `${author.ID}`, name: author.display_name }))}
                        labelName={'Author'}
                        state={newsArchiveCtx.setAuthor}
                        value={newsArchiveCtx.author}
                        multiple={false}
                    />
                </li>
                <li className="pr-4 sm:pr-8 sm:border-r border-light-gray/35 last:border-none">
                    <SelectInput
                        options={tags.map(tag => ({ id: `${tag.id}`, name: tag.name }))}
                        labelName={'Tag'}
                        state={newsArchiveCtx.setTags}
                        value={newsArchiveCtx.tags}
                        multiple={true}
                    />
                </li>
                {/* <li className="pr-4 sm:pr-8 sm:border-r border-light-gray/35 last:border-none">
                    <SelectInput
                        options={sort}
                        labelName={"Sort"}
                        state={newsArchiveCtx.setSort}
                        value={newsArchiveCtx.sort}
                        multiple={false}
                    />
                </li> */}
            </ul>
        </div>
    );
};

export default NewsCategoryTabs;
